<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle"></span>
        <h3 class="page-title">Laporan Donatur</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card mb-4">
          <div class="card-body p-1 pb-3" style="overflow-x:scroll">
            <d-row style="margin:auto">
              <d-col md="3"  class="form-group" style="text-align:left">
                Tipe
                <d-select v-model="dtype" :options="dtypes" style="padding-left:1px" />
              </d-col>
              <d-col md="3"  class="form-group" style="text-align:left">
                Kategori
                <d-select v-model="category" :options="dcategories" style="padding-left:1px" />
              </d-col>
              <d-col md="3"  class="form-group" style="text-align:left">
                Lokasi
                <d-select v-model="location" :options="locations" style="padding-left:1px" />
              </d-col>
              <d-col md="3"  class="form-group" style="text-align:left">
                Asal Gky
                <d-select v-model="gky" :options="gkys" style="padding-left:1px" />
              </d-col>
            </d-row>
            <d-row style="margin:auto">
              <d-col md="3"  class="form-group" style="text-align:left">
                Gender
                <d-select v-model="gender" :options="genders" style="padding-left:1px" />
              </d-col>
              <d-col md="2"  class="form-group" style="text-align:left">
                Batas bawah umur
               <d-form-input type="text" id="feMinAge" placeholder="Batas bawah umur" v-model="minage" />
              </d-col>
              <d-col md="2"  class="form-group" style="text-align:left">
                Batas atas umur
               <d-form-input type="text" id="feMaxAge" placeholder="Batas atas umur" v-model="maxage" />
              </d-col>
            </d-row>
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group" style="display:none">
                <label for="feSearch">Search</label>
                <d-form-input type="text" id="feInputSearch" placeholder="Search" v-model.trim="search" />
              </d-col>
            </d-row>
            <br/><br/>
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group">
                <label for="feGo">&nbsp;</label>
                <button type="button" class="btn-primary" @click="update_data"><i class="material-icons">send</i> Go</button>
                <label v-if="show_excel" for="feGo">&nbsp;</label>
                <button v-if="show_excel" type="button" class="btn-primary is-hidden-mobile" @click="xls"><i class="material-icons">border_all</i> Excel</button>
              </d-col>
            </d-row>
            <d-row>
            <d-col md="6"  class="form-group">
            </d-col>
            </d-row>
        <b-table
            id="dtable"
            :data="isEmpty ? [] : data"
            :loading="loading"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" >
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                </b-table-column>
                <b-table-column field="gender" label="Gender" >
                    {{ props.row.gender==1 ? "Bpk": ( props.row.gender==0 ? "Ibu" : "") }}
                </b-table-column>
                <b-table-column field="fullname" label="Nama Lengkap" >
                    {{ props.row.fullname }}
                </b-table-column>
                <b-table-column field="email" label="Email" >
                    {{ props.row.email }}
                </b-table-column>
                <b-table-column field="mobile_phone" label="HP" style="text-align:right" >
                    {{ (props.row.mobile_phone=='0000000')? '':props.row.mobile_phone }}
                </b-table-column>
                <b-table-column field="dob" label="Tgl Lahir" >
                    {{ (props.row.dob=='01-01-1900')? '':props.row.dob }}
                </b-table-column>
                <b-table-column field="age" label="Umur" >
                    {{ (props.row.dob=='01-01-1900')? '':props.row.age }}
                </b-table-column>
                <b-table-column field="category" label="Kategori" >
                    {{ find_category(props.row.category) }}
                </b-table-column>
                <b-table-column field="created_by" label="Dibuat oleh" >
                    {{ props.row.created_by }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>No result</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';
import FileSaver from 'file-saver'

    export default {
        components: {
        },
        data() {
            return {
                sortField:'id',
                sortOrder:'asc',
                data:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: false,
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                defaultSortOrder:'desc',
                search:'',
                show_excel:false,
                category:'',
                categories:env.categories,
                dcategories:[],
                dtype:'',
                dtypes:env.dtypes,
                locations:[],
                location:'',
                gkys:[],
                gky:'',
                minage:'',
                maxage:'',
                gender:'',
                genders:env.genders,
            }
        },
        watch:{
          dtype(val){
           this.filter_cats(val); 
           this.category='';
          },
        },
        methods:{
          find_category(cat){
            let resp= this.categories.filter( c=>c.value==cat ) 
            return resp[0].text;
          },
          filter_cats(){
           if (this.dtype==='') this.dcategories=env.categories;
           else
           this.dcategories = this.categories.filter( (a)=>{ if (a.dtype==this.dtype) return a; else return false });
          },
          xls(){
    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>List Donatur</x:Name>';
    tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    tab_text = tab_text + "<table>";
    tab_text = tab_text + document.getElementById('dtable').childNodes[4].childNodes[0].innerHTML;
    tab_text = tab_text + '</table></body></html>';
    var file = new Blob([tab_text], {type: 'application/vnd.ms-excel;charset=utf-8;'});
    FileSaver.saveAs(file,'list_donatur.xls')
          },
          update_data(){
           this.loading=true;
           this.axios.post( env.server+'/donator-list',{
             start: 0,
             length: 0,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
             location: parseInt(this.location)>0?''+this.location:'',
             church: parseInt(this.gky)>0?''+this.gky:'',
             category: parseInt(this.category)>0?''+this.category:'',
             dtype: this.dtype!=='' ? ''+this.dtype:'',
             minage: this.minage!=='' ? ''+this.minage:'',
             maxage: this.minage!=='' ? ''+this.maxage:'',
             gender: this.gender!=='' ? ''+this.gender:'',
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.show_excel=true;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
                 let tmp=[];
                 tmp=this.data[i].dob.split('-');
                 this.data[i].dob=tmp[2]+'-'+tmp[1]+'-'+tmp[0];
               }
             }
           );
          },
        },
        mounted(){  
          let carr=[{text:'',value:''}];
          this.dcategories=carr.concat(this.categories);
          this.dtypes=carr.concat(this.dtypes);
          this.genders=carr.concat(this.genders);
          this.axios.get( env.server+'/church/all').then( resp=>{
                resp.data = JSON.parse(resp.data);
                let arr=[{text:'',value:0}];
                for(let i=0;i<resp.data.data.length;i++){
                   arr.push( { text: resp.data.data[i].name , value: resp.data.data[i].id });
                }
                this.gkys=arr;
          });
          this.axios.get( env.server+'/location/all').then( resp=>{
                resp.data = JSON.parse(resp.data);
                let arr=[{text:'',value:0}];
                for(let i=0;i<resp.data.data.length;i++){
                   arr.push( { text: resp.data.data[i].name , value: resp.data.data[i].id });
                }
                this.locations=arr;
          });
        },
    }
</script>
